<rect
    x="0.666667"
    y="0.666667"
    width="48.6667"
    height="48.6667"
    rx="24.3333"
    stroke="#E6E8EC"
    stroke-width="1.33333"
/>
<g clip-path="url(#clip0_438_119896)">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 35C30.5229 35 35 30.5229 35 25C35 19.4771 30.5229 15 25 15C19.4771 15 15 19.4771 15 25C15 30.5229 19.4771 35 25 35ZM25 37.5C31.9035 37.5 37.5 31.9035 37.5 25C37.5 18.0964 31.9035 12.5 25 12.5C18.0964 12.5 12.5 18.0964 12.5 25C12.5 31.9035 18.0964 37.5 25 37.5Z"
        fill="#777E90"
    />
    <path
        d="M23.9958 23.432C23.9958 22.8241 24.5202 22.3313 25.1672 22.3313H26.3386C26.9856 22.3313 27.5101 21.8385 27.5101 21.2306C27.5101 20.6227 26.9856 20.1299 26.3386 20.1299H25.1672C23.2263 20.1299 21.6529 21.6083 21.6529 23.432V25.6335H20.4815C19.8345 25.6335 19.3101 26.1262 19.3101 26.7342C19.3101 27.3421 19.8345 27.8349 20.4815 27.8349H21.6529V34.4392C21.6529 35.0471 22.1774 35.5399 22.8243 35.5399C23.4713 35.5399 23.9958 35.0471 23.9958 34.4392V27.8349H26.3386C26.9856 27.8349 27.5101 27.3421 27.5101 26.7342C27.5101 26.1262 26.9856 25.6335 26.3386 25.6335H23.9958V23.432Z"
        fill="#777E90"
    />
</g>
<defs>
    <clipPath id="clip0_438_119896">
        <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(12.5 12.5)"
        />
    </clipPath>
</defs>
